<template>
    <div style="width: 100%;height: 100%;background: #667aa6">
        <div class="unlock-con">
            <unlock @on-unlock="handleUnlock" :avatorPath="avatorPath"></unlock>
        </div>
    </div>
</template>

<script>
import unlock from './unlock.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        unlock,
    },
    computed: {
        avatorPath() {
            return this.$store.state.user.myInfo.avatar;
        },
    },
    methods: {
        ...mapMutations('app', ['setLockInfo']),
        handleUnlock() {
            let prevRouter = this.$store.state.app.lockInfo.routerName;
            this.setLockInfo({ routerName: '', isLock: false });
            // 解锁之后跳转到锁屏之前的页面
            this.$router.push({ name: prevRouter });
        },
    },
};
</script>
